import { render, staticRenderFns } from "./LeadAttachments.vue?vue&type=template&id=3a80762a"
import script from "./LeadAttachments.vue?vue&type=script&lang=ts"
export * from "./LeadAttachments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports